// import logo from './logoTrans.png';
import './App.css';
import { useEffect, useState } from 'react';
import { Routes, Route, Link } from "react-router-dom";
import Akatist1 from './Akatist1';
import Akatist2 from './Akatist2';


function App() {

  const [isMobile, setIsMobile] = useState(true);

  useEffect(() => {
    setIsMobile(() => /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))
  })

  function Home() {
    return <>
      {/* <img src='logoTrans.png' alt='logo' style={{width: isMobile ? "50%" : "20%", marginTop: 100}}/>
      <h3 style={{marginTop: "30px" ,...blueColor}}>Dragi posetioci sajta i čitaoci Akatista</h3>
      <h3  style={{marginTop: "20px" ,...blueColor}}>Zbog tehničkog unapređenja sajta, sajt</h3>
      <h3  style={blueColor}>će ponovo biti dostupan kroz 7 dana.</h3>
      <h3 style={{marginTop: "20px", ...redColor}}>Za sva pitanja, pišite na instagram</h3>
      <h3 style={redColor}>@dijana.duhovnostupraksi</h3>
      <h3  style={{marginTop: "20px" ,...blueColor}}>Hvala Vam na razumevanju i strpljenju,</h3>
      <h3  style={blueColor}>vaša Hadži Dijana Ninić</h3> */}
      <img src='logoTrans copy.png' alt='logo' style={{width: '50%', marginTop: 100}} />
      <div style={{ display: 'flex ', marginTop: '15px', flexDirection: "column", gap: "14px", justifyContent: "center", alignItems: 'center', height: '100%'}}>
        <h3>Linkovi za akatiste</h3>
        <Link style={{fontSize: 20, textDecoration: 'none'}} to="/akatist-svetom-jefremu-cudotvorcu-neamakrijskom">AKATIST SVETOM JEFREMU ČUDOTVORCU NEAMAKRIJSKOM</Link> 
        <Link style={{fontSize: 20, textDecoration: 'none'}} to="/akatist-svetim-ajudskim-mucenicima">AKATIST SVETIM AJUDSKIM MUČENICIMA KOMUNISTIČKIH ZATVORA</Link>
      </div>
    </>;
  }
  
  function About() {
    return <h2>About Page</h2>;
  }

  const blueColor = { color: 'blue'}
  const redColor = { color: 'red'}

  return (
    <div className="App">
    {/* Navigation */}
    {/* <nav>
      <Link to="/">Home</Link> |{" "}
      <Link to="/about">About</Link>
    </nav> */}

    {/* Page Routes */}
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/akatist-svetom-jefremu-cudotvorcu-neamakrijskom" element={< Akatist1/>}/>
      <Route path="/akatist-svetim-ajudskim-mucenicima" element={< Akatist2/>}/>
    </Routes>
  </div>
);
}

export default App;
 